import { SPARTAN_LINEUP_SECTION_ID } from '@/app/lcv/components/sections/spartan/shared/lineup/constants';

export const SPARTAN_PRODUCT_SECTION_ANCHORS = {
  hero: 'hero',
  exterior: 'exterior',
  interior: 'interior',
  accessories: 'accessories',
  rssdump: 'rssdump',
  'feature-showcase': 'highlights',
  flatdeck: 'flatdeck',
  engine: 'performance',
  adas: 'adas',
  video: 'video',
  'explore-features': 'features',
  customize: 'customize',
  lineup: SPARTAN_LINEUP_SECTION_ID,
  cta: 'other-services',
} as const;

export type SpartanProductSectionAnchor =
  (typeof SPARTAN_PRODUCT_SECTION_ANCHORS)[keyof typeof SPARTAN_PRODUCT_SECTION_ANCHORS];

export const SPARTAN_PRODUCT_HERO_BANNER_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.hero;

export const SPARTAN_PRODUCT_EXTERIOR_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.exterior;

export const SPARTAN_PRODUCT_INTERIOR_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.interior;

export const SPARTAN_PRODUCT_ACCESSORIES_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.accessories;

export const SPARTAN_PRODUCT_SPARK_ACCESSORIES_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.rssdump;

export const SPARTAN_PRODUCT_FEATURE_SHOWCASE_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS['feature-showcase'];

export const SPARTAN_PRODUCT_FLATDECK_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.flatdeck;

export const SPARTAN_PRODUCT_ENGINE_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.engine;

export const SPARTAN_PRODUCT_ADAS_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.adas;

export const SPARTAN_PRODUCT_VIDEO_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.video;

export const SPARTAN_PRODUCT_EXPLORE_FEATURES_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS['explore-features'];

export const SPARTAN_PRODUCT_CUSTOMIZE_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.customize;

export const SPARTAN_PRODUCT_LINEUP_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.lineup;

export const SPARTAN_PRODUCT_CTA_SECTION_ID =
  SPARTAN_PRODUCT_SECTION_ANCHORS.cta;
